import clsx from "clsx";
import { useState } from "react";
import { ICategoryDesc, ICategoryOption, IOption } from "../../types/customizer";
import If from "../If";
import SwatchOption from "../SwatchOption";
import questionMark from '../../../assets/images/question-mark.svg';
import GroupMaterialInfo from "./GroupMaterialInfo";
import DiamondInfo from "./DiamondInfo";
import PersonalizedMachinePatternInfo from './PersonalizedMachinePatternInfo';
import AppModal from "../AppModal";
import { useRingCustomizerContext } from '../../context/RingCustomizerContext';
import { APP_STYLES, DEFAULT_STYLES } from "../../../utils/basic";

interface ISwatchCategory {
  name: string;
  category_desc?: Array<ICategoryDesc> | null;
  parentName?: string;
  options: Array<IOption | ICategoryOption>;
  hasSwatch: boolean;
  fieldType: string;
  selectedOption: IOption;

  onChange: (updated: any) => void;
  isChanging: string;
  rootCategory?: boolean;
  hideMoreInfo?: boolean;
  evenGrid?: boolean;
  tab?: string;
 }

 export const customStyles = {
   content: {
     top: '50%',
     left: '50%',
     right: 'auto',
     bottom: 'auto',
     zIndex: 100,
     minWidth: '300px',
     transform: 'translate(-50%, -50%)'
   }
 };

 const SwatchCategory = ({ name, category_desc, parentName, options, hasSwatch, fieldType, selectedOption,
   onChange, isChanging, rootCategory, hideMoreInfo, evenGrid, tab }: ISwatchCategory) => {

   const { subpath } = useRingCustomizerContext();

   const [enableMoreOption] = useState(false);
   const [seeMore, setSeeMore] = useState(true);
   const [modalIsOpen, setIsOpen] = useState(false);

   const openModal = () => {
     setIsOpen(true);
   };

   const closeModal = () => {
     setIsOpen(false);
   };

   /*useEffect(() => {
     if (displayShowMoreOption) {
       const isAnySubCategory = items.find(i => i.type === 'category');
       setEnableMoreOption(!isAnySubCategory && items.length > 5);
     }
   }, [displayShowMoreOption, items]);

   const options = enableMoreOption && seeMore ? items.slice(0, 5) : items;*/
   const hasSubCategory = options.find(item => item.type === 'category');

   const style = APP_STYLES[subpath] || DEFAULT_STYLES;
   return (
     <div
       className={clsx({
         'category-wrapper tw-pt-2 tw-w-full': true,
         'tw-border-none': hasSubCategory,
         'tw-border-dashed tw-border-gray-100 tw-border-b-2': !rootCategory && !hasSubCategory,
       })}
     >
       {name && name !== parentName &&
       <div className={clsx("tw-flex tw-text-sm tw-text-primary-color tw-font-semibold primary-font-family", {
         'md:tw-justify-center tw-uppercase': style.alignOptions === 'center',
       })}>
         {name}
         {(name === 'Premium Diamond' || name === 'Standard Diamond' || (name === 'Personalized' && !['legacy-touch', 'legacy-touch-dev'].includes(subpath))) ?
           <button className="tw-bg-transparent tw-border-none hover:tw-bg-transparent hover:tw-border-none p-0 tw-leading-none focus:tw-outline-0 focus:tw-shadow-none focus:tw-border-none" onClick={openModal}><img src={questionMark} className="tw-pl-1" alt="none" /></button> :
            null}
       </div>}
       <div className={clsx('tw-flex tw-w-full', {
          'tw-flex-wrap': hasSubCategory || rootCategory || style.alignOptions === 'center',
          'tw-overflow-x-auto': !hasSubCategory,
          'md:tw-justify-center' : style.alignOptions === 'center',
        })}>
         {options.map((option: IOption | ICategoryOption, index: number) => {
           if (option.type === 'category') {
             return (
               <SwatchCategory
                 key={index}
                 name={option.name}
                 category_desc={option.category_desc}
                 parentName={name}
                 options={option.items}
                 hasSwatch={hasSwatch}
                 fieldType={fieldType}
                 selectedOption={selectedOption}

                 onChange={onChange}
                 isChanging={isChanging}
                 hideMoreInfo={hideMoreInfo}
                 tab={tab}
               />
             );
           } else if (option.type === 'option') {
             return (
               <SwatchOption
                 key={index}
                 {...option}
                 tab={tab}
                 hasSwatch={hasSwatch}
                 fieldType={fieldType}
                 onChange={onChange}
                 selectedOption={selectedOption}
                 isChanging={isChanging}
                 moreInfo={selectedOption?.description}
                 hideMoreInfo={hideMoreInfo}
                 evenGrid={evenGrid}
               />
             );
           }
           return null;
         })}
         <If condition={enableMoreOption && hasSwatch}>
           <div className="tw-w-28 tw-h-28 tw-p-2.5 tw-mr-5 tw-mt-2" role="presentation" onClick={() => setSeeMore(!seeMore)}>
             <div
               className="tw-w-full tw-h-full tw-rounded-full tw-flex tw-justify-center tw-items-center tw-cursor-pointer tw-border
        tw-border-solid tw-border-cyan hover:tw-bg-cyan hover:tw-text-white tw-text-sm tw-text-cyan tw-font-semibold"
             >
               {seeMore ? 'See More' : 'See Less'}
             </div>
           </div>
         </If>
         <If condition={enableMoreOption && !hasSwatch}>
           <div className="tw-p-2 tw-cursor-pointer" role="presentation" onClick={() => setSeeMore(!seeMore)}>
             <div
               className="tw-p-2 tw-rounded-lg tw-cursor-pointer tw-border tw-border-solid
        tw-border-cyan hover:tw-bg-cyan hover:tw-text-white tw-text-sm tw-text-cyan tw-font-semibold"
             >
               {seeMore ? 'See More' : 'See Less'}
             </div>
           </div>
         </If>
       </div>

       {category_desc?.length && category_desc.length > 1 ?
         <GroupMaterialInfo
           isOpen={modalIsOpen}
           onClose={closeModal}
           descriptions={category_desc}
           tab={tab}
         /> : null
       }
       {(name === 'Premium Diamond' || name === 'Standard Diamond') ?
        <AppModal size="md" isOpen={modalIsOpen} onClose={closeModal}>
            <DiamondInfo />
        </AppModal> : null
      }
      {(name === 'Personalized') ?
        <AppModal size="md" isOpen={modalIsOpen} onClose={closeModal}>
          <PersonalizedMachinePatternInfo />
        </AppModal> : null
      }
     </div>);
 };

 export default SwatchCategory;
